/**
 * La Dorée Studio — Cart Drawer
 * Handles open/close, quantity updates, and live cart refresh via Shopify Cart API
 */

(function () {
  'use strict';

  var drawer = document.getElementById('ld-cart-drawer');
  var overlay = document.getElementById('ld-drawer-overlay');
  var closeBtn = document.getElementById('ld-drawer-close');

  if (!drawer) return;

  /* ── OPEN / CLOSE ── */
  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    overlay.removeAttribute('aria-hidden');
    drawer.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    closeBtn && closeBtn.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* Close on overlay click */
  overlay && overlay.addEventListener('click', closeDrawer);
  closeBtn && closeBtn.addEventListener('click', closeDrawer);

  /* Close on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  /* ── TRIGGER — any element with [data-open-drawer] or .ld-open-drawer ── */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-open-drawer], .ld-open-drawer');
    if (trigger) {
      e.preventDefault();
      refreshDrawer().then(openDrawer);
    }
  });

  /* ── CART API HELPERS ── */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return 'AUD $' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function setLoading(on) {
    var items = document.getElementById('ld-drawer-items');
    if (items) items.classList.toggle('ld-drawer-loading', on);
  }

  function updateCartChange(key, quantity) {
    setLoading(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateDrawerUI(cart);
        updateNavCount(cart.item_count);
        setLoading(false);
        return cart;
      })
      .catch(function (err) {
        console.error('[LD Cart] update failed', err);
        setLoading(false);
      });
  }

  function refreshDrawer() {
    return fetch('/cart.js', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateDrawerUI(cart);
        updateNavCount(cart.item_count);
        return cart;
      });
  }

  /* ── UPDATE NAV BAG COUNT ── */
  function updateNavCount(count) {
    /* Targets any element with data-ld-cart-count or class ld-cart-count-label */
    document.querySelectorAll('[data-ld-cart-count], .ld-cart-count-label').forEach(function (el) {
      el.textContent = count;
    });
    /* Also update parenthetical "(0)" pattern in nav bag button */
    document.querySelectorAll('[data-ld-bag-btn]').forEach(function (el) {
      el.textContent = el.textContent.replace(/\(\d+\)/, '(' + count + ')');
    });
  }

  /* ── RE-RENDER DRAWER FROM CART JSON ── */
  function updateDrawerUI(cart) {
    var itemsEl = document.getElementById('ld-drawer-items');
    var totalEl = document.getElementById('ld-drawer-total');
    var countEl = document.getElementById('ld-drawer-count');
    var apEl = document.getElementById('ld-ap-amount');
    var footer = drawer.querySelector('.ld-drawer-footer');
    var afterpay = document.getElementById('ld-drawer-afterpay');

    if (countEl) {
      countEl.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items');
    }

    if (cart.item_count === 0) {
      if (itemsEl) {
        itemsEl.innerHTML =
          '<div class="ld-drawer-empty">' +
          '<div class="ld-drawer-empty-diamond"></div>' +
          '<div class="ld-drawer-empty-title">Your bag is empty</div>' +
          '<p class="ld-drawer-empty-sub">Browse our boutique Shopify templates and find the one made for your brand.</p>' +
          '<a href="/collections/all" class="ld-drawer-shop-btn">Browse Templates</a>' +
          '</div>';
      }
      if (footer) footer.style.display = 'none';
      if (afterpay) afterpay.style.display = 'none';
      return;
    }

    if (footer) footer.style.display = '';
    if (afterpay) afterpay.style.display = '';

    /* Rebuild items HTML */
    if (itemsEl) {
      var html = '';
      cart.items.forEach(function (item) {
        var imgHtml = item.image
          ? '<img src="' + item.image + '" alt="' + (item.product_title || '') + '" width="72" height="54" loading="lazy">'
          : '';
        var typeHtml = item.product_type
          ? '<div class="ld-drawer-item-type">' + item.product_type + '</div>'
          : '';
        var tagHtml = '';
        if (item.properties && item.properties['_card_tag']) {
          tagHtml = '<div class="ld-drawer-item-tag">' + item.properties['_card_tag'] + '</div>';
        }
        var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
          ? '<div class="ld-drawer-item-variant">' + item.variant_title + '</div>'
          : '';
        var wasHtml = item.original_line_price !== item.final_line_price
          ? '<span class="ld-drawer-item-was">' + formatMoney(item.original_line_price) + '</span>'
          : '';

        html +=
          '<div class="ld-drawer-item" data-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="ld-drawer-item-img">' + imgHtml + typeHtml + '</a>' +
          '<div>' +
          tagHtml +
          '<a href="' + item.url + '" class="ld-drawer-item-name">' + item.product_title + '</a>' +
          variantHtml +
          '<div class="ld-drawer-item-bottom">' +
          '<div class="ld-d-qty-wrap">' +
          '<button class="ld-d-qty-btn ld-d-minus" data-key="' + item.key + '" aria-label="Decrease">−</button>' +
          '<div class="ld-d-qty-num" data-key="' + item.key + '">' + item.quantity + '</div>' +
          '<button class="ld-d-qty-btn ld-d-plus" data-key="' + item.key + '" aria-label="Increase">+</button>' +
          '</div>' +
          '<div>' + wasHtml +
          '<span class="ld-drawer-item-price" data-key="' + item.key + '">' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
          '</div>' +
          '</div>' +
          '</div>';
      });
      itemsEl.innerHTML = html;
    }

    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    if (apEl) apEl.textContent = formatMoney(Math.round(cart.total_price / 4));
  }

  /* ── QUANTITY BUTTONS IN DRAWER ── */
  drawer.addEventListener('click', function (e) {
    var btn = e.target.closest('.ld-d-minus, .ld-d-plus');
    if (!btn) return;

    var key = btn.dataset.key;
    var qtyEl = drawer.querySelector('.ld-d-qty-num[data-key="' + key + '"]');
    if (!qtyEl) return;

    var current = parseInt(qtyEl.textContent, 10) || 0;
    var newQty = btn.classList.contains('ld-d-minus')
      ? Math.max(0, current - 1)
      : current + 1;

    qtyEl.textContent = newQty;
    updateCartChange(key, newQty);
  });

  /* ── ADD TO CART — intercept Shopify form submits to open drawer ── */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        return refreshDrawer();
      })
      .then(openDrawer)
      .catch(function (err) {
        console.error('[LD Cart] add failed', err);
        /* Fall back to normal form submission */
        form.submit();
      });
  });

  /* ── EXPOSE GLOBALLY for theme use ── */
  window.LDCart = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshDrawer
  };

})();
